import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from './broadcaster.service';
import { Area } from '../area';

@Injectable()
export class LandEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(data: Area): void {
    this.broadcaster.broadcast(LandEvent, data);
  }

  on(): Observable<Area> {
    return this.broadcaster.on<Area>(LandEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/broadcaster/LandEvent.ts